import { render, staticRenderFns } from "./StockLocalList.vue?vue&type=template&id=50cc735d&"
import script from "./StockLocalList.vue?vue&type=script&lang=js&"
export * from "./StockLocalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports